import { Sponsors } from '@/components/admin/sponsorships/Sponsors';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';

export default restrictedRoute(Sponsors, {
  requiresEvery: [RouteRestrictions.ADMIN_ROLE],
});
